<template>
  <!-- 气泡型 -->
  <div class="bubble-list">
    <div class="bubbleList-head">
      <div class="bubbleList-head-tip">{{ content.tit }}</div>
    </div>
    <div v-if="contentList && contentList.length" class="bubbleList-body">
      <template v-if="isGroupType">
        <template v-for="item in contentList">
          <li class="bubbleList-body-head">
            <div class="left">
              <img :src="item.logo" alt="" class="logo">
              <div class="tit">{{ item.name }}</div>
            </div>
            <div class="right">
              <div class="status">{{ item.status }}</div>
            </div>
          </li>
          <bubble-item @chooseItem="chooseItem" v-if="item.subList && item.subList.length"
            :list="item.subList"></bubble-item>
        </template>
      </template>
      <bubble-item @chooseItem="chooseItem" v-else :list="contentList"></bubble-item>
    </div>
    <div class="bubbleList-bottom" v-if="hasNext || isShowLoading">
      <div class="more-btn" v-if="hasNext" @click="loadMore">查看更多</div>
      <i v-else-if="isShowLoading" class="loading loading-s"></i>
    </div>
  </div>
</template>

<script>
import BubbleItem from './BubbleItem';
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
    isShowLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BubbleItem,
  },
  data() {
    return {
      content: {},  // 消息内容
      contentList: [], // 列表
      tab: [], // tab列表
      hasNext: false, // 是否有下一页
      isGroupType: true,
    };
  },
  watch: {
    message: {
      deep: true,
      handler(val) {
        this.parseMessage(val);
      },
    },
  },
  mounted() {
    this.parseMessage(this.message);
  },
  methods: {
    loadMore() {
      this.hasNext = false;
      this.$emit('loadMore', { type: 'bubble' });
    },
    chooseItem(item) {
      this.$emit('chooseItem', item);
    },
    parseMessage(message) {
      const { content: { content: { contentData: { contentList = [], tab = [] } } } } = message; // 消息解构一下，避免渲染的时候字段层级太深
      this.content = message?.content?.content;;
      this.hasNext = this.content.contentData?.hasNext;
      this.contentList = contentList;
      this.tab = tab;
      this.isGroupType = this.content.templateId === 4;
    },

  },
};
</script>

<style lang="less" scoped>
@import './common.less';
.bubbleList-body {
  padding: 0;
}

// 气泡列表
.bubble-list {
  // width: 286px;
  // border-radius: 6px;
  // box-shadow: 0 1px 10px 0 #e1e6f0;
  // margin-top: 12px;
  // background-color: #ffffff;
  overflow: hidden;
  width: 256px;

  .bubbleList-head {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #262d3d;
    padding: 13px 0;
  }

  .bubbleList-body-head {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    background: #f8f9fb;

    .left {
      display: flex;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #262d3d;

      .logo {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }

    .right {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      color: #78849e;
    }
  }

  .bubbleList-bottom {
    // background: #ffffff;
    box-shadow: inset 0px 0.7px 0px #f0f0f0;
    padding: 11px 0 0;
    position: relative;
    height: 18px;
    transform-origin: 0px 0px;
    opacity: 1;
    transform: scale(1, 1);

    .more-btn {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #4a70ff;
      transform-origin: 0px 0px;
      opacity: 1;
      transform: scale(1, 1);
    }
  }
}</style>
